// import axios from 'axios';
import api from "./../api";
import Swal from 'sweetalert2';
import UtilsUrl from '../../utils/UtilsUrl';


const addContractType = (formData) => {
    return api.post(UtilsUrl.rhURL() + `/contract_types/add_contract_type`, formData);
};
const getContractTypes = (idUser) => {
    return api.get(UtilsUrl.rhURL() + "/contract_types/" + idUser);
};
const updateContractType = (contract_typeModel) => {
    return api.post(UtilsUrl.rhURL() + `/contract_types/update_contract_type/`,
        contract_typeModel
    );
};
const deleteContractType = async (contracttypeID, setContracttypes) => {
    try {
        const result = await Swal.fire({
            title: 'Es-tu sûr?',
            text: 'Vous ne pourrez pas annuler cette action !',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Oui, supprimez-le !',
            cancelButtonText: 'Non, annulez !',
            reverseButtons: true,
        });

        if (result.isConfirmed) {
            await api.put(UtilsUrl.rhURL() + `/contract_types/archive_contract_type/${contracttypeID}`, { isDeleted: true });

            Swal.fire('Supprimé !', 'Le type de contrat supprimé avec succès.', 'success');

            setContracttypes((prevState) => prevState.filter((contracttype) => contracttype.id !== contracttypeID));
        } else if (result.dismiss === Swal.DismissReason.cancel) {
            Swal.fire('Cancelled', 'Your file is safe :)', 'error');
        }
    } catch (error) {
        console.error(error);
    }
};
const checknomContrat = (nomContrat, idUser) => {
    return api.get(UtilsUrl.rhURL() + "/contract_types/checknomcontrat/" + nomContrat + "/" + idUser);
    // try {
    //     const response = await
    //     return response.data;
    // } catch (error) {
    //     throw error.response.data;
    // }
};
export { getContractTypes, updateContractType, addContractType, deleteContractType, checknomContrat };